export interface Coordinates {
  readonly latitude: number;
  readonly longitude: number;
}

export interface ConfirmedLocation extends Coordinates {
  readonly accuracy?: number;
  readonly confirmedAt: string;
}

// A viewport is not a delivery selection and must never be included in checkout payloads.
export function deliveryViewport(
  selected: Coordinates | undefined,
  address: { readonly latitude?: number; readonly longitude?: number } | undefined
): { readonly center: Coordinates; readonly zoom: number } | undefined {
  if (validCoordinates(selected)) return { center: selected, zoom: 15 };
  const center = {
    latitude: address?.latitude ?? Number.NaN,
    longitude: address?.longitude ?? Number.NaN
  };
  return validCoordinates(center) ? { center, zoom: 13 } : undefined;
}

export function confirmedLocation(
  latitude: number,
  longitude: number,
  confirmedAt: string,
  accuracy?: number
): ConfirmedLocation {
  return {
    latitude,
    longitude,
    ...(accuracy === undefined ? {} : { accuracy }),
    confirmedAt
  };
}

export function validCoordinates(value: Coordinates | undefined): value is Coordinates {
  return Boolean(
    value &&
      Number.isFinite(value.latitude) &&
      value.latitude >= -90 &&
      value.latitude <= 90 &&
      Number.isFinite(value.longitude) &&
      value.longitude >= -180 &&
      value.longitude <= 180
  );
}

export function geolocationErrorMessage(code: number): string {
  if (code === 1)
    return 'Localização não autorizada. Você ainda pode escolher o ponto em Procurar no mapa.';
  if (code === 2)
    return 'Sua localização está indisponível. Tente novamente ou escolha o ponto no mapa.';
  if (code === 3)
    return 'A localização demorou demais. Tente novamente ou escolha o ponto no mapa.';
  return 'Não foi possível obter sua localização. Escolha o ponto no mapa.';
}

export function accuracyMessage(accuracy: number | undefined): string | undefined {
  if (accuracy !== undefined && accuracy > 100)
    return 'A precisão está baixa. Confira e ajuste o marcador antes de enviar.';
  return undefined;
}

export function checkoutModeAvailable(
  mode: 'PICKUP' | 'DELIVERY',
  pickupEnabled: boolean,
  deliveryEnabled: boolean,
  activeAreaCount: number
): boolean {
  return mode === 'PICKUP' ? pickupEnabled : deliveryEnabled && activeAreaCount > 0;
}
